import { Instagram, Twitter, Facebook, Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = [
    { icon: Instagram, label: "Instagram", url: "https://instagram.com" },
    { icon: Twitter, label: "Twitter", url: "https://twitter.com" },
    { icon: Facebook, label: "Facebook", url: "https://facebook.com" },
    
  ];

  const platformLinks = [
    { label: "The Platform", path: "/" },
    { label: "Pricing", path: "/pricing" },
  ];

  const agencyLinks = [
    
    { label: "The Agency", path: "/landing-page-2" },
    { label: "Consultation", path: "/agency-pricing" },
    { label: "Careers", path: "/careers" },
  ];

  const legalLinks = [
    { label: "Privacy Policy", path: "/privacy" },
    { label: "Terms of Service", path: "/terms" },
    { label: "Cookie Policy", path: "/cookies" },
    { label: "GDPR Compliance", path: "/gdpr" },
    { label: "Agency Partnership", path: "/agency-partnership-agreement" },
    { label: "Business Verification", path: "/business-verification-policy" },
    { label: "Payments & Payouts", path: "/payments-policy" },
    { label: "Collaboration & Work Terms", path: "/collaboration-terms" },
  ];

  const handleEmailClick = () => {
    window.location.href = "mailto:info@metrocitygroove.online";
  };

  return (
    <footer 
      className="bg-black border-t border-white/20" 
      aria-label="Site footer"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <img 
                  src="/lovable-uploads/metro-city-groove-logo-white.png" 
                  alt="Metro City Groove Logo" 
                  className="w-14 h-14 object-contain"
                  width="48"
                  height="48"
                  loading="lazy"
                />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white tracking-tight">
                  Move to the Groove
                </h2>
                <p className="text-sm text-gray-300 font-medium mt-1">Urban Digital Hub</p>
              </div>
            </div>
            
            <p className="text-gray-400 text-base leading-relaxed max-w-md">
              Revolutionising the Culture and Creative Arts, Media and Entertainment Technology industries 
              through cutting-edge digital innovation and community-driven experiences.
            </p>
            
            {/* Social Links */}
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-colors duration-300"
                    aria-label={`Follow us on ${social.label}`}
                  >
                    <social.icon className="w-6 h-6" />
                  </a>
                ))}
              </div>
              
              {/* Email Contact */}
              <button
                onClick={handleEmailClick}
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors duration-300 group"
                aria-label="Contact us via email"
              >
                <Mail className="w-5 h-5" />
                <span className="text-sm group-hover:underline">
                  info@metrocitygroove.online
                </span>
              </button>
            </div>
          </div>

          {/* Platform Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">
              MCG Platform
            </h3>
            <ul className="space-y-3">
              {platformLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm block py-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Agency Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">
              MCG Agency
            </h3>
            <ul className="space-y-3">
              {agencyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm block py-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">
              Legal
            </h3>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm block py-1"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} Metro City Groove (Pty) Ltd. All rights reserved.
              <br className="sm:hidden" />
              <span className="hidden sm:inline"> • </span>
              Engineered by Metro City Trading
            </p>
            
            <div className="flex flex-col items-center md:items-end space-y-2">
              <p className="text-gray-400 text-sm text-center md:text-right font-medium">
                Made For The Media Arts and Culture Community Technology Industry
              </p>
              <p className="text-gray-500 text-xs">
                Durban • Johannesburg • Cape Town • Nairobi • Botswana
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;